var _rect, _circle, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigBindingCoilLongRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 88,
    viewBox: "0 0 106 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 8,
    width: 80,
    height: 106,
    rx: 4,
    transform: "rotate(90 106 8)",
    fill: "#BCBDC0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.666,
    cy: 48.1123,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5113 59.999H64.9113V46.199C64.9113 42.799 64.9113 35.399 54.6613 35.399C50.8613 35.399 47.1113 36.549 44.4613 39.249L47.6113 42.399C49.2113 40.899 51.5113 39.899 54.0113 39.899C57.2113 39.899 59.5113 41.449 59.5113 44.399V45.049H58.0113C52.0113 45.049 42.9113 45.599 42.9113 53.399C42.9113 58.149 47.2113 60.599 51.6613 60.599C54.8613 60.599 57.6613 59.399 59.3613 56.699H59.5113V59.999ZM59.1613 50.599C59.1613 53.949 57.2113 56.099 53.1113 56.099C51.1613 56.099 48.9113 55.149 48.9113 52.949C48.9113 49.499 54.6113 49.249 57.9113 49.249H59.1613V50.599Z",
    fill: "#52B3A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 14.1113,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 99 14.1113)",
    fill: "#52B3A7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 14.1113,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 90 14.1113)",
    fill: "#52B3A7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 14.1113,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 81 14.1113)",
    fill: "#52B3A7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 14.1113,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 72 14.1113)",
    fill: "#52B3A7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 14.1113,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 63 14.1113)",
    fill: "#52B3A7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 14.1113,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 54 14.1113)",
    fill: "#52B3A7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 14.1113,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 45 14.1113)",
    fill: "#52B3A7"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 14.1113,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 36 14.1113)",
    fill: "#52B3A7"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 14.1113,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 27 14.1113)",
    fill: "#52B3A7"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 14.1113,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 18 14.1113)",
    fill: "#52B3A7"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 8.83398,
    y: 14.1113,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 8.83398 14.1113)",
    fill: "#52B3A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigBindingCoilLongRight);
export default __webpack_public_path__ + "static/media/jobconfig-binding-coil-long-right.8a2b1e50b9d013399dd63f8f61b14217.svg";
export { ForwardRef as ReactComponent };